import {createStore} from 'vuex';
import authModule from './auth';
import BaseData from './baseData';
import BaseConfig from './baseConfig';
import Author from './author';
import User from './user';
import uiModule from './ui';
import Notif from './notif';
import Keys from './keys';

export default createStore({
    modules: {
        auth:       authModule,
        baseData:   BaseData,
        baseConfig: BaseConfig,
        author:     Author,
        user:       User,
        ui:         uiModule,
        notif:      Notif,
        keys:       Keys
    }
});
